require("./main.css");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "theme", () => $1c70aef5f8d466b3$export$bca14c5b3b88a9c9);
var $47fda6fc0877c5b3$exports = {};

$parcel$export($47fda6fc0877c5b3$exports, "spectrum--dark", () => $47fda6fc0877c5b3$export$68dc111a79481afd, (v) => $47fda6fc0877c5b3$export$68dc111a79481afd = v);
var $47fda6fc0877c5b3$export$68dc111a79481afd;
$47fda6fc0877c5b3$export$68dc111a79481afd = "spectrum--dark_44765c";


var $5fc600550714d659$exports = {};

$parcel$export($5fc600550714d659$exports, "spectrum--darkest", () => $5fc600550714d659$export$4ecdba604f5f1f44, (v) => $5fc600550714d659$export$4ecdba604f5f1f44 = v);
var $5fc600550714d659$export$4ecdba604f5f1f44;
$5fc600550714d659$export$4ecdba604f5f1f44 = "spectrum--darkest_256eeb";


var $33116a1ac1f127f3$exports = {};

$parcel$export($33116a1ac1f127f3$exports, "spectrum", () => $33116a1ac1f127f3$export$3311ab3a441bc141, (v) => $33116a1ac1f127f3$export$3311ab3a441bc141 = v);
$parcel$export($33116a1ac1f127f3$exports, "spectrum--medium", () => $33116a1ac1f127f3$export$4c0c83b3f4303ef8, (v) => $33116a1ac1f127f3$export$4c0c83b3f4303ef8 = v);
$parcel$export($33116a1ac1f127f3$exports, "spectrum--large", () => $33116a1ac1f127f3$export$a88a8dbe29386d31, (v) => $33116a1ac1f127f3$export$a88a8dbe29386d31 = v);
$parcel$export($33116a1ac1f127f3$exports, "spectrum--darkest", () => $33116a1ac1f127f3$export$4ecdba604f5f1f44, (v) => $33116a1ac1f127f3$export$4ecdba604f5f1f44 = v);
$parcel$export($33116a1ac1f127f3$exports, "spectrum--dark", () => $33116a1ac1f127f3$export$68dc111a79481afd, (v) => $33116a1ac1f127f3$export$68dc111a79481afd = v);
$parcel$export($33116a1ac1f127f3$exports, "spectrum--light", () => $33116a1ac1f127f3$export$efb37c2f79da8163, (v) => $33116a1ac1f127f3$export$efb37c2f79da8163 = v);
$parcel$export($33116a1ac1f127f3$exports, "spectrum--lightest", () => $33116a1ac1f127f3$export$baaa804dc80cce18, (v) => $33116a1ac1f127f3$export$baaa804dc80cce18 = v);
var $33116a1ac1f127f3$export$3311ab3a441bc141;
var $33116a1ac1f127f3$export$4c0c83b3f4303ef8;
var $33116a1ac1f127f3$export$a88a8dbe29386d31;
var $33116a1ac1f127f3$export$4ecdba604f5f1f44;
var $33116a1ac1f127f3$export$68dc111a79481afd;
var $33116a1ac1f127f3$export$efb37c2f79da8163;
var $33116a1ac1f127f3$export$baaa804dc80cce18;
$33116a1ac1f127f3$export$3311ab3a441bc141 = "spectrum_9e130c";
$33116a1ac1f127f3$export$4c0c83b3f4303ef8 = "spectrum--medium_9e130c";
$33116a1ac1f127f3$export$a88a8dbe29386d31 = "spectrum--large_9e130c";
$33116a1ac1f127f3$export$4ecdba604f5f1f44 = "spectrum--darkest_9e130c";
$33116a1ac1f127f3$export$68dc111a79481afd = "spectrum--dark_9e130c";
$33116a1ac1f127f3$export$efb37c2f79da8163 = "spectrum--light_9e130c";
$33116a1ac1f127f3$export$baaa804dc80cce18 = "spectrum--lightest_9e130c";


var $ed6c61a7b1f80a21$exports = {};

$parcel$export($ed6c61a7b1f80a21$exports, "spectrum--large", () => $ed6c61a7b1f80a21$export$a88a8dbe29386d31, (v) => $ed6c61a7b1f80a21$export$a88a8dbe29386d31 = v);
var $ed6c61a7b1f80a21$export$a88a8dbe29386d31;
$ed6c61a7b1f80a21$export$a88a8dbe29386d31 = "spectrum--large_c40598";


var $7ada9fcc793cf5cf$exports = {};

$parcel$export($7ada9fcc793cf5cf$exports, "spectrum--medium", () => $7ada9fcc793cf5cf$export$4c0c83b3f4303ef8, (v) => $7ada9fcc793cf5cf$export$4c0c83b3f4303ef8 = v);
var $7ada9fcc793cf5cf$export$4c0c83b3f4303ef8;
$7ada9fcc793cf5cf$export$4c0c83b3f4303ef8 = "spectrum--medium_4b172c";


let $1c70aef5f8d466b3$export$bca14c5b3b88a9c9 = {
    global: (/*@__PURE__*/$parcel$interopDefault($33116a1ac1f127f3$exports)),
    light: (/*@__PURE__*/$parcel$interopDefault($47fda6fc0877c5b3$exports)),
    dark: (/*@__PURE__*/$parcel$interopDefault($5fc600550714d659$exports)),
    medium: (/*@__PURE__*/$parcel$interopDefault($7ada9fcc793cf5cf$exports)),
    large: (/*@__PURE__*/$parcel$interopDefault($ed6c61a7b1f80a21$exports))
};


